module.exports = __webpack_public_path__ + "static/media/mark-shine.d6642052.mp3";